import React, {useState} from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import Modal from 'ui-library/modals/Modal';

import SearchableUnitDropdown from './SearchableUnitDropdown';

// Keep in sync with benchling/units/constants/network_constants.py
export const CLEAR_UNIT_SENTINEL = 'CLEAR_UNIT_SENTINEL';

export interface UnitSelectionModalResult {
  unitApiIdentifier?: string | null;
  unitSymbol?: string | null;
}

interface Props {
  onRequestClose: () => void;
  onRequestSubmit: (result: UnitSelectionModalResult) => void;
  existingUnitId?: string | null;
  existingUnitSymbol?: string | null;
  readOnly: boolean;
  readOnlyReason?: string;
  selectionWarningMessage?: string;
  forFieldCreation?: boolean;
}
export default function UnitSelectionModal(props: Props): JSX.Element {
  const initialUnitId = props.existingUnitId ?? null;
  const [selectedUnitId, setSelectedUnitId] = useState<string | null>(initialUnitId);
  const [selectedUnitSymbol, setSelectedUnitSymbol] = useState<string | null>(
    props.existingUnitSymbol ?? null
  );
  const noneUnitValue = props.forFieldCreation ? null : CLEAR_UNIT_SENTINEL;

  return (
    <Modal
      title="Select a unit"
      small={true}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        props.onRequestSubmit({
          unitApiIdentifier: selectedUnitId ?? noneUnitValue,
          unitSymbol: selectedUnitSymbol ?? null,
        });
      }}
      buttons={[
        {text: 'Cancel', cancel: true},
        {
          text: 'Save',
          submit: true,
          disabled: props.readOnly || selectedUnitId === initialUnitId,
        },
      ]}
    >
      {props.readOnly && props.readOnlyReason && (
        <div className="u-spacing-bottom">
          <InlineBanner bannerType={InlineBannerType.INFO} text={props.readOnlyReason} />
        </div>
      )}
      {!props.readOnly && props.selectionWarningMessage && (
        <div className="u-spacing-bottom">
          <InlineBanner bannerType={InlineBannerType.INFO} text={props.selectionWarningMessage} />
        </div>
      )}
      <div style={{width: '200px'}}>
        <SearchableUnitDropdown
          disabled={props.readOnly}
          onSelect={(unit) => {
            setSelectedUnitId(unit ? unit.id : null);
            setSelectedUnitSymbol(unit ? unit.symbol : null);
          }}
          selectedId={selectedUnitId}
          includeNone={true}
        />
      </div>
    </Modal>
  );
}
